import styled from 'styled-components';

export const ContactContainer = styled.div`
    height: 750px;
    z-index: 0; 
`;

export const ContactWrap = styled.div`
    height: 100%; 
    display: flex; 
    flex-direction: column; 
    justify-content: center;

    @media screen and (max-width: 400px){
        height: 80%;
    }
`;

export const ContactContent = styled.div`
    height: 100%; 
    display: flex; 
    flex-direction: column; 
    justify-content: center; 

    @media screen and (max-width: 480px){
        padding: 10px; 
    }
`;

export const ContactForm = styled.form`
    background: #010101; 
    max-width: 500px;
    height: auto; 
    width: 100%; 
    z-index: 1; 
    display: grid; 
    margin: 0 auto; 
    padding: 42px 32px; 
    border-radius: 4px; 
    box-shadow: 0 1px 3px rgba(0,0,0,0.9);

    @media screen and (max-width: 400px){
        padding: 32px 32px; 
    }

    @media screen and (max-width: 768px){
        max-width: 400px;
    }
`;

export const FormH1 = styled.h1`
    margin-bottom: 40px;  
    font-size: 30px; 
    text-align: center; 
`;

export const FormLabel = styled.label`
    margin-bottom: 8px; 
    font-size: 14px; 
`;

export const FormInput = styled.input`
    margin-bottom: 12px; 
    padding: 16px 16px; 
    border: none; 
    border-radius: 4px; 
`;

export const FormButton = styled.button`
    padding: 16px 0; 
    border: none; 
    border-radius: 4px; 
    font-size: 20px; 
    cursor: pointer; 
`;


export const FormArea = styled.textarea`
    margin-bottom: 20px; 
    padding: 16px 16px; 
    border: none; 
    border-radius: 4px; 
    resize: none;
    font-size: 9pt;
`;

